export const TITLE = 'Car Compare';

export const IMAGE_DIR = '/images';
export const API_BASE = '';

export const RESULTSIZE = 6;

export const FilterSteps = {
  Specs: 'Specs',
  Features: 'Features',
  Prefs: 'Preferences',
};

export const REQUIRED = 'Required';
export const IGNORE = 'Ignore';
export const PREFERRED = 'Prefer';

export const YES = 'Y';
export const NO = '-';

export const HATCH = 'H';
export const SEDAN = 'S';
export const SUV = 'SUV';
